// src/components/ReportModal.js

import React, { useState } from 'react';

const reportReasons = [
    "Envolve criança ou adolescente (abuso ou exploração)",
    "Item Proibido (drogas, armas, etc.)",
    "Anúncio Falso ou Enganoso",
    "Conteúdo Ofensivo ou de Ódio",
    "Item Roubado ou Falsificado",
    "Spam ou Anúncio Repetido",
    "Outro (descreva abaixo)"
];

export default function ReportModal({ onClose, onSubmit, itemName }) {
    const [reason, setReason] = useState('');
    const [otherReason, setOtherReason] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!reason) {
            alert("Por favor, selecione um motivo para a denúncia.");
            return;
        }
        const finalReason = reason === "Outro (descreva abaixo)" ? otherReason : reason;
        if (!finalReason) {
            alert("Por favor, descreva o motivo da denúncia.");
            return;
        }
        onSubmit(finalReason);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg mx-auto">
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Denunciar Item</h2>
                <p className="text-center text-gray-500 mb-6">Você está denunciando o item: <span className="font-semibold">{itemName}</span></p>
                
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <p className="text-sm font-medium text-gray-700">Por favor, selecione o motivo da denúncia:</p>
                        {reportReasons.map((r) => (
                            <div key={r} className="flex items-center">
                                <input
                                    id={r}
                                    name="report_reason"
                                    type="radio"
                                    checked={reason === r}
                                    onChange={() => setReason(r)}
                                    className="h-4 w-4 text-green-600 border-gray-300 focus:ring-green-500"
                                />
                                <label htmlFor={r} className="ml-3 block text-sm text-gray-800">
                                    {r}
                                </label>
                            </div>
                        ))}
                        {reason === "Outro (descreva abaixo)" && (
                            <textarea
                                value={otherReason}
                                onChange={(e) => setOtherReason(e.target.value)}
                                rows="2"
                                className="mt-2 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
                                placeholder="Descreva o motivo..."
                            />
                        )}
                    </div>

                    <div className="mt-8 flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700"
                        >
                            Enviar Denúncia
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

